<template>
  <div :class="['pta-flags', customClass]">
    <div class="pta-flags__header">
      <span class="pta-flags__header-title">
        {{ capturedFlags }} of {{ flags.length }} flags captured
      </span>
      <span v-if="!canSubmit" class="pta-flags__header-request">
        Please start the lab to submit flags.
      </span>
      <span
        v-if="canResetFlag"
        class="pta-flags__header-reset"
        @click="resetFlags"
      >
        Reset flags
      </span>
    </div>
    <div class="pta-flags__flag-wrapper">
      <div v-for="flag in flags" :key="flag.uuid" class="pta-flags__flag">
        <PTAFlag
          :flag="flag"
          :userFlagStatus="userFlags ? userFlags[flag.uuid] || {} : {}"
          :canSubmit="canSubmit"
          :labsRequestPayload="labsRequestPayload"
          :loadingAnswer="loadingAnswer"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import PTAFlag from '@/components/modals/lab-modal/PTAFlag.vue'
import CONSTANTS from '@/constants'

export default {
  name: 'PTACatchTheFlag',
  components: {
    PTAFlag,
  },
  props: {
    currentLab: {
      type: Object,
      required: true,
    },
    customClass: {
      type: String,
      default: '',
    },
    sessionStatus: {
      type: String,
      required: true,
    },
    labsRequestPayload: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {
      loadingAnswer: false,
    }
  },
  computed: {
    ...mapGetters({
      userFlags: 'labs/userFlags',
    }),
    flags() {
      return this.currentLab.flags
    },
    capturedFlags() {
      const captured = Object.values(this.userFlags).filter(f => {
        return f.has_passed
      })
      return captured ? captured.length : 0
    },
    canSubmit() {
      return this.sessionStatus === CONSTANTS.LABS.SESSION_STATUS.STARTED
    },
    hasPassed() {
      return this.userFlagStatus?.has_passed
    },
    canResetFlag() {
      return (
        this.sessionStatus === CONSTANTS.LABS.SESSION_STATUS.STARTED &&
        this.capturedFlags > 0 &&
        this.currentLab.is_skill_check
      )
    },
  },
  methods: {
    async resetFlags() {
      this.loadingAnswer = true
      await this.$store.dispatch('labs/resetUserFlags', {
        ...this.labsRequestPayload,
        labId: this.currentLab.id,
      })
      this.loadingAnswer = false
    },
  },
}
</script>
<style lang="scss" scoped>
.pta-flags {
  width: 100%;
  margin-bottom: 40px;
  padding: 20px;
  text-align: left;
  background: linear-gradient(
    111.02deg,
    rgba(18, 18, 18, 0.7) 3.86%,
    rgba(18, 18, 18, 0) 107.96%
  );
  border: 1px solid var(--tundora-gray);
  box-sizing: border-box;
  border-radius: 10px;
  color: var(--white);
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    &-title {
      font-size: 18px;
      margin-bottom: 15px;
    }
    &-request {
      display: none;
      color: var(--white);

      font-size: 0.75rem;
      font-style: normal;
      font-weight: 500;
      line-height: 1rem;

      @include desktop {
        display: initial;
      }
    }
    &-reset {
      text-decoration: underline;
      font-size: 14px;
      color: var(--light-blue-gray);
      line-height: 20px;
      margin-bottom: 15px;
      cursor: pointer;
      text-decoration: underline;
    }
  }
}
</style>
